<template>
  <div>
    <div @click="Qzqx" v-if="state.ifQz" class="zzc" >
        <div @click.stop="xx()"  class="signature-container">
            <div class="" style="width: 9vmin;height: 9vmin;margin: 0 auto;">
                <img class="wh100" src="https://image.giantgocloud.com/www/ImageMapping/image/20250427/140A23167F2C47A08C6AE288DE9D2823.png" mode="widthFix"></img>
            </div>
            <div style="text-align: center;margin-top: 0.9vmin;font-weight: 600;font-size: 4.4vmin;color: #3C3C3C;">
                请签下您的名字
            </div>
            <div class="signature-container_qz">

                <canvas ref="signatureCanvas"
                class="signature-canvas"
                :width="domBox.width"
                :height="domBox.height"
                @mousedown="startDrawing"
                @mousemove="draw"
                @mouseup="stopDrawing"
                @mouseout="stopDrawing"
                @touchstart="startDrawingTouch"
                @touchmove="drawTouch"
                @touchend="stopDrawingTouch"
                @touchcancel="stopDrawingTouch"></canvas>
                <div class="signature-container_qz_tip">
                    请在此区域签字
                </div>
            </div>

            <div style="height: 10vh;" class="a_flex">
                <div class="orderDetails_btn a_flex" style="padding: 4vmin 13.9vmin;" @click="clearCanvas">清空</div>
                <div style="margin-left: 0.4vmin;padding: 4vmin 13.9vmin;" class="orderDetails_btn a_flex" @click="saveSignature">确认</div>
            </div>
        </div>
    </div>
    <div :style="state.ifQ?'width:1190px;':''" :class="state.ifQz?'vh90':''" class="informedConsentAgreement">
        <div class="informedConsentAgreement_title">
            个性化营养补充剂配置增值服务知情同意协议
        </div>
        <div class="informedConsentAgreement_P1">
            欢迎您选择 <div
                class="textA">{{state.dataT.organizationName}}</div>（以下简称“本中心”）的个性化营养补充剂增值服务。为了保障您的合法权益，确保您充分了解并自愿接受本机构的服务，请您仔细阅读本知情同意协议，阅读本明确知情同意协议中的甲方为<div
                class="textA">{{state.dataT.organizationName}}</div>，乙方为阅读本知情同意书的你本人，并在确认无误后签署。
        </div>
        <div class="informedConsentAgreement_titleA">
            一、服务背景与目的
        </div>
        <div class="informedConsentAgreement_P2">
            乙方通过甲方平台提交个人健康信息（包括临床数据、生活方式问卷及健康评估结果），甲方基于营养学研究成果与科学文献，分析您的健康问题的潜在影响因素，并制定个性化膳食补充方案。为提升使用便利性，甲方提供免费配制服务，将乙方所需补充剂按建议方案配制为小包装。
        </div>
        <div class="informedConsentAgreement_P3">
            特别声明：本服务为营养支持服务，不构成医疗建议，不可替代药品或临床治疗。
        </div>
        <div class="informedConsentAgreement_titleA">
            二、服务内容说明
        </div>
        <div class="informedConsentAgreement_titleB">
            1：客户购买产品清单
        </div>
        <div class="informedConsentAgreement_P2">
            本中心以您的饮食状况、生活方式、问卷信息、临床和衰老数据为基础，遵循循证原则，为你推荐身体所需的营养补充剂方案，这些产品均符合国家食品法规要求，以固体饮料（粉剂）形式提供：
        </div>
        <div class="informedConsentAgreement_P2" v-for="(item,index) in state.dataT.productNameList" :key="index" >
            <div class="textA"><div class="textB">{{index+1}}）产品名称：</div>{{item}}</div>
        </div>
       <!-- <div class="informedConsentAgreement_P2">
            <div class="textA"><div class="textB">2）产品名称：</div>[具体产品名称2]</div>
        </div> -->
        <div class="informedConsentAgreement_P2">
            （根据实际产品清单，可继续添加其他产品）
        </div>
        <div class="informedConsentAgreement_titleB">
            2：配制服务细则
        </div>
        <div class="informedConsentAgreement_P2">
            甲方为乙方免费提供个性化配制服务细则包括：
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            1）配制依据：根据您购买的多种单品产品，按产品每次用量、建议服用时间AI算法辅助生成配制方案，最终方案需经人工审核后生效
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            2）精准<div class="textC">配制：</div>通过全自动设备配制为每日<div class="textC">2-3</div>次独立小包装；
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            3）透明化标识：每餐小包装贴有详尽成分标签，标注单品分配方案；保质期及储存条件（如“避光、阴凉处保存，开封后需冷藏”）。
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            4）服用指导：根据健康数据提供个性化服用时间建议
        </div>
        <div class="informedConsentAgreement_titleB">
            3：服务流程：
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            1）乙方知晓自己所购的产品是如何配制，以及确定了解所购买产品的备案凭证；
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            2）甲方在配制之前，必须进行风险提示：
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC">- 配制过程每个独立包装的剂量可能存在偏差±3%）；</div>
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC">- 配制后产品保质期缩短为原包装的70%（具体以配制标签为准），需在标注期限内使用；</div>
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            3）乙方确认配制方案后，甲方于24小时内完成配制，全程记录配制过程；
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            4）乙方签收后需核对配制信息，如有问题需在48小时内反馈。
        </div>
        <div class="informedConsentAgreement_titleA">
            三、乙方权利与义务
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            1）不同体质的人群对产品的反应可能存在差异。在使用前，建议您仔细阅读产品标签和说明书，了解产品的成分、适用人群及注意事项。如您在使用过程中出现任何不适或疑似过敏反应，请立即停止使用，并及时咨询专业人士；
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            2）乙方可随时查询、下载购买记录及配制方案；
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            3）提供真实、完整的健康信息，若因隐瞒或误填导致方案偏差，责任自负；
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            4）甲方应在配制前向乙方提供所购产品的备案信息（包括生产许可证号、产品标准号和产品备案信息等）
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            5）按推荐方案服用，不得超量或与其他药物/补充剂混用；
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            6）对配制准确性提出异议，甲方需配合复检；
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            7）在配制完成之前，乙方有权要求暂停、终止配制服务。
        </div>
        <div class="informedConsentAgreement_titleA">
            四、数据隐私与安全
        </div>
        <div class="informedConsentAgreement_titleB">
            1. 甲方遵循《个人信息保护法》，对乙方健康信息加密存储，仅用于制定营养补充方案；
        </div>
        <div class="informedConsentAgreement_titleB">
            2. 未经乙方书面同意，不得向第三方提供数据，法律要求除外。
        </div>
        <div class="informedConsentAgreement_titleA">
            五、甲方免责声明
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC"> 1）本服务不是医疗服务，乙方须知悉营养补充不能替代药物治疗；</div>
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC"> 2）配制服务为免费增值项目，乙方签署本协议即视为已知悉并自愿接受配制服务的免费性质及可能存在的合理风险 ； </div>
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC"> 3）免责范围： </div>
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC">- 因乙方未按照配制标签说明储存、服用产品导致的后果；</div>
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC">- 甲方在配制前已经出具企业营业执照编号和自己购买的单品产品备案信息等信息，乙方已知晓配置配制一切信息，仍提出异议或退换货要求；</div>
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC"> 4）配制产品属于乙方个人专属产品，禁止给予或销售给他人使用，若违反本条款，甲方不承担他人使用产品而产生的任何服务和纠纷； </div>
        </div>
        <div style="text-indent: 1em;" class="informedConsentAgreement_P2">
            <div class="textC"> 5）如遇国家政策调整导致服务终止，甲方有权提前30日通知乙方。</div>
        </div>
        <div class="informedConsentAgreement_titleA">
            六、协议生效与变更
        </div>
        <div class="informedConsentAgreement_P2">
            1. 乙方勾选确认下述条款后，本同意书生效：
        </div>
        <div class="informedConsentAgreement_P2">
            本人知晓自己购买了哪些单品产品，个性化配置是由这些产品配制，以及如何配制；
        </div>
        <div class="informedConsentAgreement_P2">
            本人已仔细阅读本知情同意协议，充分了解并自愿接受本机构提供的个性化营养补充剂增值配制服务；
        </div>
        <div class="informedConsentAgreement_P2">
            本人理解本中心提供的营养补充剂产品为普通食品，不能代替特殊医学用途配方食品、婴幼儿配方食品、保健食品等特殊食品；
        </div>
        <div class="informedConsentAgreement_P2">
            乙方签署本协议即视为已知悉并<div class="textC">自愿接受配制服务的免费性质</div>及可能存在的合理风险。甲方保留根据法规调整服务的权利，重大变更将提前30日通知乙方。
        </div>
        <div class="informedConsentAgreement_P2" style='margin-top: 20px;'>
            <van-checkbox-group  v-model="checkList">
              <van-checkbox @click='checkboxChange' name="本人已阅读并自愿接受所有条款" checked-color="#1aad19">本人已阅读并自愿接受所有条款</van-checkbox>
              <van-checkbox style="margin-top: 20px;" @click='checkboxChange' name="本人同意授权甲方处理健康信息并提供配制服务" checked-color="#1aad19">本人同意授权甲方处理健康信息并提供配制服务</van-checkbox>
            </van-checkbox-group>
        </div>
        <div v-if='state.ifQ' style="display: flex;flex-direction: column;align-items: flex-end;">
          <div style="width: 500px;">
            <div style="font-weight: 700;" class="informedConsentAgreement_P2">
                客户签名:<img style="width: 400px;margin-top: -40px;" :src="state.dataT.signaturePic" />
            </div>
            <div style="font-weight: 700;" class="informedConsentAgreement_P2">
                签署日期:{{state.dataT.signatureTime}}
            </div>
          </div>

        </div>

    </div>
  </div>

</template>

<script>
import { ref } from 'vue'

import { Toast } from 'vant'
import H5Report from '@/api/index'
import axios from 'axios'
export default {
  data () {
    return {
      ifCG: true,
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      context: null,
      domBox: {},
      state: {
        ifQ: false,
        fileUrl: '',
        ifQz: false,
        upDataT: '',
        selectUserData: '',
        dataT: {
          organizationName: '',
          productNameList: []
        }
      },
      checkList: [],
      type: 0
    }
  },
  mounted () {
    const that = this
    this.orderId = this.$route.query.orderId
    this.type = this.$route.query.type
    axios
      .post(
        // `https://healthingcoretest.giantgocloud.com/api/SceneCheckPage/GetPrecisePdfPageData`,
        `${H5Report}/boardApi/CustomScheme/GetSignaturePDFInfo`, {
          OrderId: this.$route.query.orderId
        }
      ).then(res => {
        console.log('返回值', res)
        if (res.data.data && res.data.data.signaturePic && that.type == 1) {
          that.state.dataT = res.data.data
          that.state.ifQ = true
          that.checkList = ['本人已阅读并自愿接受所有条款', '本人同意授权甲方处理健康信息并提供配制服务']
        } else {
          that.state.dataT = res.data.data
        }
        console.log('that.state.dataT', that.state.dataT)
      })
  },
  methods: {
    checkboxChange (e) {
      console.log('选项改变', this.checkList)
      if (this.ifCG) {
        if (this.state.ifQ) {
          this.checkList = ['本人已阅读并自愿接受所有条款', '本人同意授权甲方处理健康信息并提供配制服务']
        } else {
          if (this.checkList.length == 2) {
            this.state.ifQz = true
            setTimeout(() => {
              this.domBox = document.getElementsByClassName('signature-canvas')[0].getBoundingClientRect()

              console.log('this.domBox', this.domBox)
            }, 10)
          }
        }
      } else {
        this.checkList = ['本人已阅读并自愿接受所有条款', '本人同意授权甲方处理健康信息并提供配制服务']
      }
    },
    Qzqx () {
      this.state.ifQz = false
    },
    startDrawing (e) {
      console.log('startDrawing', e)
      const canvas = this.$refs.signatureCanvas
      const ctx = canvas.getContext('2d')
      this.isDrawing = true
      this.lastX = e.offsetX
      this.lastY = e.offsetY
      console.log('this.lastX', this.lastX)
      ctx.beginPath()
      ctx.moveTo(this.lastX, this.lastY)
    },
    draw (e) {
      console.log('draw', e)
      if (!this.isDrawing) return
      const canvas = this.$refs.signatureCanvas
      const ctx = canvas.getContext('2d')
      ctx.lineTo(e.offsetX, e.offsetY)
      ctx.stroke()
      this.lastX = e.offsetX
      this.lastY = e.offsetY
    },
    stopDrawing () {
      if (!this.isDrawing) return
      this.isDrawing = false
    },
    startDrawingTouch (e) {
      console.log('startDrawingTouch', e)
      const canvas = this.$refs.signatureCanvas
      const ctx = canvas.getContext('2d')
      this.isDrawing = true
      const touch = e.touches[0]
      this.lastX = touch.clientX - this.domBox.left
      this.lastY = touch.clientY - this.domBox.top
      ctx.beginPath()
      ctx.moveTo(this.lastX, this.lastY)
      e.preventDefault()
    },
    drawTouch (e) {
      console.log('drawTouch', e)
      if (!this.isDrawing) return
      const canvas = this.$refs.signatureCanvas
      const ctx = canvas.getContext('2d')
      const touch = e.touches[0]
      console.log('touch.clientX - canvas.offsetLeft', canvas.offsetLeft)
      console.log('touch.clientY - canvas.offsetTop', canvas.offsetTop)
      ctx.lineTo(touch.clientX - this.domBox.left - canvas.offsetLeft, touch.clientY - this.domBox.top - canvas.offsetTop)
      ctx.stroke()
      this.lastX = touch.clientX - this.domBox.left - canvas.offsetLeft
      console.log('this.lastX', this.lastX)
      this.lastY = touch.clientY - this.domBox.top - canvas.offsetTop
      e.preventDefault()
    },
    stopDrawingTouch () {
      if (!this.isDrawing) return
      this.isDrawing = false
    },
    xx () {

    },
    clearCanvas () {
      const canvas = this.$refs.signatureCanvas
      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, 1000, 1000)
      this.signatureImage = null
    },
    saveSignature () {
      const that = this
      const canvas = this.$refs.signatureCanvas
      this.signatureImage = canvas.toDataURL('image/png')
      console.log('this.signatureImage', this.signatureImage)
      axios
        .post(
          `${H5Report}/boardApi/Tools/UpLoadBase64`, {
            ext: 'png',
            base64: that.signatureImage
          }
        ).then(res => {
          console.log('发送', res)
          if (res.data.code == 200) {
            axios
              .post(
              `${H5Report}/boardApi/Customized/SaveSignature`, {
                Signature: res.data.data,
                OrderId: that.orderId
              }
              ).then(res => {
                that.state.ifQz = false
                Toast(res.data.msg)
                that.ifCG = false
                // setTimeout(() => {
                //   location.reload()
                // }, 2000)
              })
          }
        })
    }
  }
}

// const GetSignaturelnfoF () {
//   console.log('that.state.upDataT', that.state.upDataT)
//   console.log('that.state.selectUserData', that.state.selectUserData)
//   const data = {
//     CustomerCode: that.state.selectUserData.customerCode,
//     ProductPreOrderInfoModel: that.state.upDataT
//   }
//   GetSignaturelnfo(data)
//     .then((res) => {
//       console.log('GetSignaturelnfo', res)
//       that.state.dataT = res.data
//     })
// }

</script>

<style lang="scss" scoped>
    .informedConsentAgreement {
        padding: 20px 40px;
        box-sizing: border-box;
        div {
            font-weight: 200;
        }

        .textA {
          display: inline;
            color: #0000ff;
        }

        .textB {
          display: inline;
            font-weight: 700;
            color: #0000ff;
        }

        .textC {
          display: inline;
            font-weight: 700;
        }

        .informedConsentAgreement_title {
            text-align: center;
            font-size: 20px;
            font-weight: 700;
            color: #000000;
        }

        .informedConsentAgreement_P1 {
            margin-top: 10px;
            color: #000000;
            font-size: 12px;
            line-height: 20px;
            text-indent: 2em;
        }

        .informedConsentAgreement_titleA {
            margin-top: 30px;
            margin-left: 5px;
            font-size: 12px;
            font-weight: 700;
            color: #000000;
        }

        .informedConsentAgreement_P2 {
            margin-top: 10px;
            color: #000000;
            font-size: 12px;
            line-height: 20px;
            margin-left: 40px;
        }

        .informedConsentAgreement_P3 {
            margin-top: 10px;
            font-size: 12px;
            font-weight: 700;
            color: #000000;
        }

        .informedConsentAgreement_titleB {
            margin-top: 30px;
            font-size: 12px;
            font-weight: 700;
            color: #000000;
            font-weight: 700;
        }
    }
    .orderDetails_btn {
        margin: 0 auto;
        display: inline-flex;
        margin-top: 2.7vmin;
        padding: 0vmin 15.9vmin;
        height: 5vmin;
        background: linear-gradient(180deg, #20CED6 0%, #13989F 100%);
        border-radius: 40.3vmin;
        font-size: 3.7vmin;
        color: #FFFFFF;
    }

    .orderDetails_btnB_text {
        margin-left: 1vmin;
        font-size: 1.6vmin;
        color: #FFFFFF;
    }

    .orderDetails_btnB {
        display: inline-flex;
        padding: 0vmin 11vmin;
        height: 5vmin;
        background: linear-gradient(180deg, #20CED6 0%, #13989F 100%);
        border-radius: 40.3vmin;
        font-size: 1.7vmin;
        color: #FFFFFF;
    }

    .signature-container {
        box-sizing: border-box;
      position: fixed;
          z-index: 99;
          padding: 2.3vmin;
          text-align: center;
          width: 86vmin;
          // height: 50.8vmin;
          left: 50%;
          top: 50%;
          transform: translate(-43vmin, -25.4vmin);
          background: #fff;
          border-radius: 4.7vmin;
          .signature-container_qz{
              position: relative;
              margin: 0 auto;
              margin-top: 1.3vmin;
              width: 73.3vmin;
              height: 44.4vmin;
              // transform: translate(-27.65vmin, -10.2vmin);
              border-radius: 1.4vmin 1.4vmin 1.4vmin 1.4vmin;
              border:0.2vmin dashed #A6A4A4;
              .signature-container_qz_tip{
                  width: 100%;
                  text-align: center;
                  top: 40%;
                  position: absolute;
                  font-weight: 500;
                  font-size: 3.2vmin;
                  color: #A6A4A4;
              }
          }
    }
    .vh90{
        overflow: hidden;
        height: 88vmax;
    }
    .signature-canvas {
      position: absolute;
      z-index: 999;
      width:100%;
      height:100%;
      left:0;
      top:0;
    // border: 1px solid #ccc;
    cursor: crosshair;
    }
</style>
